import { useParams, Navigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CaseDetailContent from './components/CaseDetailContent';
import RelatedCases from './components/RelatedCases';
import { casesData } from '@/mocks/cases';

export default function CaseDetailPage() {
  const { id } = useParams<{ id: string }>();
  const item = casesData.find((c) => c.id === id);

  if (!item) {
    return <Navigate to="/cases" replace />;
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <CaseDetailContent item={item} />
        <RelatedCases current={item} all={casesData} />
      </main>
      <Footer />
    </div>
  );
}
